<section class="cmn-innerpage-wrapper">
  <div class="head">
    <h1>{{ videoId ? "Edit Video Story" : "New Video Story" }}</h1>
  </div>
  <div class="scroll-wrapper" *ngIf="!contentLoading">
    <form id="translation" class="translationForm" [formGroup]="translationForm">
      <div class="full-width-Wrapper">
        <div class="lang-wrapper">
          <label>
            <mat-form-field>
              <mat-select formControlName="langId" placeholder="Language" (selectionChange)="onLanguageSelect($event)">
                <mat-option *ngFor="let lang of languages" [value]="lang.id" [disabled]="isLangUsed(lang.id)">
                  {{ lang.name }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="translationForm.get('langId')?.hasError('required')">Language is required</mat-error>
            </mat-form-field>
          </label>
        </div>
      </div>
      <label class="full-width-Wrapper block-pointer">
        <span>Video Title</span>
        <mat-form-field>
          <input type="text" formControlName="name" matInput placeholder="Video title" maxlength="51" />
          <mat-error *ngIf="translationForm.get('name')?.hasError('required')">
            Video title is required
          </mat-error>
          <mat-error *ngIf="translationForm.get('name')?.hasError('maxlength')">
            Video title cannot exceed 50 characters
          </mat-error>
          <mat-error *ngIf="translationForm.get('name')?.hasError('onlySpaces')">
            Video title cannot be empty
          </mat-error>
          <mat-error *ngIf="translationForm.get('name')?.hasError('onlySpecialChars')">
            Video title cannot contain only special characters
          </mat-error>
        </mat-form-field>
      </label>
      <div class="full-width-Wrapper add-button-div block-pointer" *ngIf="videoTranslations.length !== languages.length">
        <p class="add-translation" [style.visibility]="
            videoTranslations.length === 0 ? 'visible' : 'hidden'">
          Add at least one translation to save
        </p>

        <button type="button" (click)="addVideoTranslation()" class="add-button  unblock-pointer">
   Add
        </button>

      </div>
    </form>
    <div *ngIf="videoTranslations?.length" class="tableWrapper">
      <table>
        <thead>
          <tr>
            <th>No</th>
            <th>Language</th>
            <th>Video title</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let video of videoTranslations; let i = index">
            <td>{{ i + 1 }}</td>
            <td>{{ getLanguageName(video.langId) }}</td>
            <td>{{ video.name }}</td>
            <td>
              <div class="actionWrapper">
                <div class="actionItem" *ngIf="video.langId !== 1" (click)="onDeleteCategory(i)">
                  <img src="../../../assets/images/icons/icon-delete.svg" alt="" />
                </div>
                <div class="actionItem" (click)="editVideoTranslation(i)">
                  <img src="../../../assets/images/icons/icon-edit.svg" alt="" />
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <form class="videoContentForm" [formGroup]="videoContentForm">
      <div class="grid-wrapper">
        <div class="audio-video-wrapper">
          <span>
            <div class="audioActionWrapper">
              <label class="checkbox-option">
                <input type="checkbox" [checked]="videoSource === 'upload'"
                  (click)="$event.preventDefault(); setVideoSource('upload')" class="hidden-checkbox"
                  [attr.aria-checked]="videoSource === 'upload'" />
                <h6 [class.activeSelector]="videoSource === 'upload'">
                  Upload Video
                </h6>
              </label>
              <label class="checkbox-option">
                <input type="checkbox" [checked]="videoSource === 'url'"
                  (click)="$event.preventDefault(); setVideoSource('url')" class="hidden-checkbox"
                  [attr.aria-checked]="videoSource === 'url'" />
                <h6 [class.activeSelector]="videoSource === 'url'">
                  Video URL
                </h6>
              </label>
            </div>
          </span>
          <div class="borderedWrapper block-pointer">
            <div class="fileSection" [class.hidden-section]="videoSource !== 'upload'">
              <label for="videoFile" [class.hidden-section]="videoSource !== 'upload'" class="unblock-pointer">
                Choose A File
                <input type="file" id="videoFile" (change)="onVideoUpload($event)" accept=".mp4, .mov"
                  #videofileInput />
              </label>
              <div class="uploadedFiles" [class.hidden-section]="videoSource !== 'upload'" *ngIf="videoFileName">
                <ul>
                  <li>
                    <h6>{{ videoFileName }}</h6>
                    <img src="../../../assets/images/icons/icon-close.svg" alt="Remove" style="cursor: pointer"
                      class="unblock-pointer" (click)="clearVideoUpload()" />
                  </li>
                </ul>
              </div>
            </div>
            <h6 [class.hidden-section]="videoSource !== 'upload'">
              Video should be in MP4 or MOV format and not exceed 300MB in size.
            </h6>
            <div [class.hidden-section]="videoSource !== 'url'">
              <mat-form-field>
                <input type="text" matInput placeholder="Video URL" formControlName="videoUrl" class="urlInput" />
              </mat-form-field>
            </div>
            <h6 [class.hidden-section]="videoSource !== 'url'">
              Video should be in MP4 or MOV format
            </h6>
          </div>
        </div>
        <label class="block-pointer">
          <span>Upload Thumb Image</span>
          <div class="borderedWrapper">
            <div class="fileSection">
              <label for="thumbFile" class="unblock-pointer">
                Choose A File
                <input type="file" id="thumbFile" (change)="onThumbUpload($event)" accept=".jpeg, .jpg, .png, .webp"
                  #thumbfileInput />
              </label>
              <div class="uploadedFiles" *ngIf="thumbFileName">
                <ul>
                  <li>
                    <h6>{{ thumbFileName }}</h6>
                    <img src="../../../assets/images/icons/icon-close.svg" alt="Remove" style="cursor: pointer"
                      class="unblock-pointer" (click)="clearThumbUpload()" />
                  </li>
                </ul>
              </div>
            </div>
            <h6>
              Image should be in JPG, JPEG or PNG format and not exceed 15MB in
              size.
            </h6>
          </div>
        </label>
      </div>
      <label>
        <span>Tags</span>
        <div class="tags-collection">
          <div class="tags-item" *ngFor="let tag of tags" [ngClass]="{
              'tags-choosed': isTagSelected(tag),
              'tags-item': !isTagSelected(tag)
            }" (click)="toggleTagSelection(tag)" style="cursor: pointer">
            <h6>{{ tag.name }}</h6>
          </div>
        </div>
      </label>
    </form>
    <div class="btnWrapper">
      <button class="cmn-cancel-btn" (click)="onCancel()">Cancel</button>
      <button [disabled]="!videoTranslations.length || isSubmitting" class="cmn-next-btn" (click)="onSubmit()">
        {{ videoId ? "Update" : "Save" }}
      </button>
    </div>
  </div>
  <app-content-loader [visible]="contentLoading"></app-content-loader>
</section>

<app-fullscreen-loader [visible]="videoUploading || thumbUploading || loading" [message]="
    videoUploading || thumbUploading
      ? 'Uploading file, please wait...'
      : 'Saving, Please wait'
  "></app-fullscreen-loader>
